import { createContext } from 'react';

export const temperatureContext = createContext('celsius');
export const featuresContext = createContext<string[]>([]);

// Helper function to convert full language name to language code
export const getLanguageCode = (languageName: string) => {
    const languageMap: Record<string, string> = {
        english: 'en',
        chinese: 'zh',
        spanish: 'es',
        french: 'fr',
        german: 'de',
        japanese: 'ja',
        korean: 'ko',
        // Add more languages as needed
    };

    return languageMap[languageName?.toLowerCase()] || 'en';
};
